"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WobiLogo = exports.Plus = void 0;
var _helpers = require("../components/utils/helpers");
var plus = (0, _helpers.getImageByAgent)('plus.svg');
var companyLogo = (0, _helpers.getImageByAgent)('companyLogo.svg');
var Plus = exports.Plus = plus;
var WobiLogo = exports.WobiLogo = companyLogo;